module.exports = __webpack_public_path__ + "static/media/mit.8342a293.svg";